import { useState, memo } from 'react';
import styles from './story-card.module.css';

export interface StoryCardProps {
  id: string;
  title: string;
  thumbnail: string;
  locked?: boolean;
  onClick: (id: string) => void;
}

export const StoryCard = memo(({ id, title, thumbnail, locked = false, onClick }: StoryCardProps) => {
  const [imageError, setImageError] = useState(false);

  const handleClick = () => {
    if (locked) return;
    onClick(id);
  };

  const handleImageError = () => {
    setImageError(true);
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (locked) return;
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onClick(id);
    }
  };

  return (
    <div 
      className={`${styles.storyCard} ${locked ? styles.locked : ''}`}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      role={locked ? 'article' : 'button'}
      tabIndex={locked ? undefined : 0}
      aria-disabled={locked || undefined}
      aria-label={locked ? `Mission non débloquée : ${title}` : `Démarrer la mission : ${title}`}
    >
      <div className={styles.storyThumbnail}>
        {thumbnail && !imageError ? (
          <img 
            src={thumbnail} 
            alt="" 
            aria-hidden="true"
            onError={handleImageError}
          />
        ) : (
          <div className={styles.thumbnailPlaceholder} aria-hidden="true">
            [Thumbnail Image]
          </div>
        )}
      </div>
      <div className={styles.storyInfo}>
        <div className={styles.storyTitle}>{title}</div>
        {locked && (
          <div className={styles.storyStatus}>Mission non débloquée</div>
        )}
      </div>
    </div>
  );
});

